import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

export function useSurveyEditId() {
  const location = useLocation();

  return useMemo(() => {
    const search = new URLSearchParams(location.search);
    const idFromQuery = search.get('surveyId');
    const parts = location.pathname.split('/').filter(Boolean);
    const idFromPath = (parts[0] === 'survey' && parts[1] && parts[1] !== 'start') ? parts[1] : null;
    const editId = idFromQuery || idFromPath;
    return {
      editId,
      isEdit: !!editId
    };
  }, [location.pathname, location.search]);
}